import { graphql } from "relay-runtime"

export const chLegalGuardianAttestationFragment = graphql`
  fragment chLegalGuardianAttestationFragment on ch_AttestationGuardian {
    id
    language
    progressNoteId
    durationFrom
    durationTo
    certificate
    firstName
    lastName
    birthDate
    updatedAt
    updatedBy
    employer
    additionalInformation
    signedAt
    signedBy
    createdAt
    createdBy
    fileId
    sentAt
    sentBy
    concludedAt
    concludedBy
    fileMetadata {
      documentType
      extension
      lengthInKilobytes
    }
  }
`
